<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic"><img src="/static/img/p11-1.jpg" width="100%" alt="蓝鲨 Robor 汽车级工业设计"></div>
          <div class="text t11">
            <div class="content">追求自由是你光鲜亮丽的外在表现</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic"><img src="/static/img/p11-2.jpg" width="100%" alt="蓝鲨 Robor 汽车级工业设计"></div>
          <div class="text t11">
            <div class="content">审慎严谨是你不流于形的深沉内敛</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic"><img src="/static/img/p11-3.jpg" width="100%" alt="蓝鲨 Robor 汽车级工业设计"></div>
          <div class="text t11">
            <div class="content">温润如玉是你儒雅随和的处世之道</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic"><img src="/static/img/p11-4.jpg" width="100%" alt="蓝鲨 Robor 汽车级工业设计"></div>
          <div class="text t11">
            <div class="content">大繁至简是你洗尽铅华的卓越非凡</div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper'
export default {
  data(){
    return {
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,swiperSlide
  },
  computed: {
    swiper(){
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination{
  bottom: 5vw !important;
}
.t11{
  top: 275px;
  left: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/swiper11.vue